'use client';

import React, { useState } from 'react';

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { label: 'À Propos', href: '#apropos' },
    { label: 'Formations', href: '#formations' },
    { label: 'Audit', href: '#audit' },
    { label: 'Conseil', href: '#conseil' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      {/* Main white header */}
      <div className="bg-white shadow-sm border-b border-gray-100">
        <nav className="max-w-7xl mx-auto px-6 md:px-10 py-2 flex items-center justify-between">
          {/* Logo */}
          <a
            href="#"
            className="flex items-center gap-3 group"
            aria-label="Inter Conseil accueil"
          >
            <img
              src="/assets/images/ChatGPT_Image_9_mars_2026_a_22_16_24-1773091006387.png"
              alt="Inter Conseil logo"
              className="h-32 w-auto object-contain"
            />
          </a>

          {/* Nav links desktop */}
          <div className="hidden lg:flex items-center gap-6">
            {navLinks.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-sm font-medium text-gray-600 hover:text-red-700 transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* CTA */}
          <div className="flex items-center gap-3">
            <a
              href="#contact"
              className="hidden sm:block text-sm font-semibold px-5 py-2.5 rounded-full bg-red-700 text-white hover:bg-red-800 transition-all duration-300"
            >
              Demander un devis
            </a>
            {/* Mobile menu button */}
            <button
              className="lg:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Menu"
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                {menuOpen ? (
                  <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
                ) : (
                  <><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>
                )}
              </svg>
            </button>
          </div>
        </nav>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-3">
            {navLinks.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-sm font-medium text-gray-700 hover:text-red-700 py-2 border-b border-gray-50"
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              className="mt-2 text-center bg-red-700 text-white font-semibold text-sm px-5 py-3 rounded-full"
              onClick={() => setMenuOpen(false)}
            >
              Demander un devis
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;